module.exports = __webpack_public_path__ + "static/media/workflow.5272c856.svg";